import React, { FC } from 'react';

import AppImage from '../../components/app-image/app-image';
import { SupportButton } from '../../containers/question-container/sub-components/question-footer/question-footer.styled';
import { lokalisation } from '../../helpers/lokalisation';
import { FooterCtnr } from './preview.styled';
import { QuestionFooterProps } from './preview.types';

export const QuestionFooter: FC<QuestionFooterProps>  = ({
    onConceptRefreshOpen,
    isConceptRefreshDisabled,
    workedSolutionDocs,
    setIsWorkedSolutionActivated,
    isWorkedSolutionActivated
}) => {
    const {
        introTxt,
        buttonTxt: { workedSolution }
    } = lokalisation();

    return (
        <FooterCtnr>
            <SupportButton
                leftIcon={<AppImage imageType={'svg'} iconType={'conceptRefreshIcon'} />}
                variant={'outline'}
                colorScheme={'white'}
                isDisabled={isConceptRefreshDisabled}
                data-testid={'concept-refresh-button'}
                onClick={onConceptRefreshOpen}
                tabIndex={-1}
            >
                {introTxt.conceptRefresh}
            </SupportButton>
            <SupportButton
                leftIcon={<AppImage imageType={'svg'} iconType={'workedSolutionIcon'} />}
                variant={'outline'}
                colorScheme={'white'}
                isDisabled={!workedSolutionDocs || workedSolutionDocs.length === 0}
                data-testid={'worked-solution-button'}
                ml={5}
                onClick={() => setIsWorkedSolutionActivated(!isWorkedSolutionActivated)}
                tabIndex={-1}
            >
                {workedSolution}
            </SupportButton>
        </FooterCtnr>
    );
};
